import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgGainage(props) {
    return (
        <Svg
            width={props.size ?? 20}
            height={props.size ?? 20}
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <G clipPath="url(#clip0_196_12874)" fill={props.color ?? baseColors.green.primary}>
                <Path d="M16.199.005C12.992.287 10.626 1.888 9.247 4.2c-.924 1.16-2.77 4.697-3.442 6.549-1.218 2.303-2.28 5.043-3.11 7.513-.509 1.51 1.772 2.496 2.283.979.621-1.848 1.372-3.846 2.22-5.7.842 1.884 1.698 3.762 2.617 5.61.712 1.435 2.854.177 2.145-1.253-.946-1.903-1.825-3.836-2.69-5.776.01-.037.025-.074.036-.11.145.04.304.053.479.02 1.324-.25 2.649-.497 3.974-.746.566-.106.783-.726.694-1.222-.268-1.486-1.115-2.52-2.169-3.498-.156-.532-.678-1.003-1.257-1.471 1.174-1.898 3.09-2.928 5.585-3.148 1.273-.111.85-2.054-.413-1.943zm-4.825 8.448c.327.34.606.699.816 1.114l-1.922.36c.323-.52.695-1.011 1.106-1.474z" />
                <Path d="M14.116 6.76a1.706 1.706 0 100-3.41 1.706 1.706 0 000 3.41z" />
            </G>
            <Defs>
                <ClipPath id="clip0_196_12874">
                    <Path fill="#fff" transform="translate(.002)" d="M0 0H20V20H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgGainage
